// Cliente Supabase inicial para CRA.
// Definir en .env.local (no commitear):
// REACT_APP_SUPABASE_URL=...
// REACT_APP_SUPABASE_ANON_KEY=...
import { createClient } from '@supabase/supabase-js';
import { safeLocalStorage } from './safeBrowserStorage';

// Permitimos también variables Vite (VITE_) como fallback por si se migra el build system.
const url = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

export const hasSupabaseEnv = !!(url && anonKey);

if(!hasSupabaseEnv) {
  console.warn('[Supabase] Faltan variables de entorno: REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY (o variantes VITE_). Usando placeholders.');
} else {
  // Evitar exponer llave en consola completa en producción
  const partial = anonKey.slice(0,6) + '...' + anonKey.slice(-4);
  console.info('[Supabase] Cliente inicializado con URL', url, 'Key', partial);
}

// Respetar preferencia de "Recordarme" si existe
let persistPref = true;
persistPref = safeLocalStorage.getItem('auth.remember') !== '0';

async function safeAuthLock(name, acquireTimeout, fn) {
  let locks = null;
  try {
    locks = typeof navigator !== 'undefined' ? navigator.locks : null;
  } catch {
    locks = null;
  }
  if (!locks?.request) return fn();
  let abortTimeoutId;
  const options = acquireTimeout === 0
    ? { mode: 'exclusive', ifAvailable: true }
    : { mode: 'exclusive' };
  if (acquireTimeout > 0 && typeof AbortController !== 'undefined') {
    const abortController = new AbortController();
    options.signal = abortController.signal;
    abortTimeoutId = setTimeout(() => abortController.abort(), acquireTimeout);
  }
  try {
    return await locks.request(
      name,
      options,
      async (lock) => (lock ? fn() : fn())
    );
  } catch (error) {
    const message = String(error?.message || '');
    if (error?.name === 'SecurityError' || /denied|access is denied/i.test(message)) {
      return fn();
    }
    throw error;
  } finally {
    if (abortTimeoutId) clearTimeout(abortTimeoutId);
  }
}

export const supabase = createClient(url || 'https://example.supabase.co', anonKey || 'anon-placeholder', {
  auth: {
    autoRefreshToken: true,
    persistSession: persistPref,
    detectSessionInUrl: true,
    storage: safeLocalStorage,
    lock: safeAuthLock
  }
});

// Obtiene el access token actual del usuario autenticado (o null si no hay sesión)
export async function getAccessToken(){
  try {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  } catch { return null; }
}

// Variante síncrona (puede entregar token desactualizado si la sesión está refrescando)
export function peekAccessTokenSync(){
  try {
    const raw = safeLocalStorage.getItem('supabase.auth.token'); // formato interno puede variar
    if(!raw) return null;
    // No confiamos en parsear el objeto interno; preferimos llamada getSession.
  } catch {}
  return null;
}
